import { Request, HttpResponse } from "./request"
import { FacilityModel } from "@/app/models/facility.model"

const providerRequest = Request("/provider/facility")
const defaultRequest = Request("/facility")

export async function findAllFacilities(): Promise<
  HttpResponse<FacilityModel[]>
> {
  return providerRequest()
    .method("GET")
    .isList()
    .returns(FacilityModel)
    .fire()
}

export async function findOneFacility(
  id: string,
): Promise<HttpResponse<FacilityModel>> {
  return defaultRequest()
    .method("GET")
    .url(`/${id}`)
    .returns(FacilityModel)
    .fire()
}
